module.exports = __webpack_public_path__ + "static/media/320.8d710303.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/res/thumbnails/320.jpg
// module id = 979
// module chunks = 0